import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KuaibaoList from "@/pages/kuaibao/page";
import KuaibaoDetail from "@/pages/kuaibao/detail/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kuaibao",
    element: <KuaibaoList />,
  },
  {
    path: "/kuaibao/:slug",
    element: <KuaibaoDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;